import { ConfigFn } from '@config/types'

const config = (() => ({ windowKey: '8l1ckD3buG' }) as const) satisfies ConfigFn

export default config
